export const SEARCH_PAGE = 'SearchPage';
export const BRIEF_PAGE = 'BriefPage';
export const TRUST_SCORE_PAGE = 'TrustScorePage';
export const TRUST_SCORE_VIEW_ORIGINAL_GUIDELINE_CLICK =
  'TrustScoreViewOriginalGuideline';
export const GUIDELINE_TITLE_CLICK = 'SearchTitleClick';
export const GUIDELINE_TITLE_CLICK_LINK_OUT = 'SearchTitleClickLinkOut';
export const GUIDELINE_BRIEF_CLICK = 'SearchBriefClick';
export const TRUST_SCORE_CARD_CLICK = 'SearchTrustScoreCardClick';
export const VIEW_ORIGINAL_GUIDELINE_CLICK = 'SearchViewOriginalGuidelineClick';
export const BRIEF_VIEW_ORIGINAL_GUIDELINE_CLICK =
  'BriefViewOriginalGuidelineClick';
export const SEARCH_FILTER = 'SearchFilter';
export const EXPORT_CONTENTFUL_DOWNLOAD = 'ExportContentfulDownload';